import LIST_FISICAL_FORMS from '@/brain/record/cbpf/list-fisical-forms'

const state = {}
const getters = {}
const mutations = {}
const actions = {
  LIST_FISICAL_FORMS
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/record/cbpf/state/index.js